import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { FaToggleOn } from 'react-icons/fa';

const Receipts = () => {
  const [cashData, setCashData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggle, setToggle] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({
    accountCode: true,
    accountName: true,
    totalBudget: true,
    flexed: true,
    actual: true,
    actualToDate: true,
    performance: true,
    difference: true,
    bPerformance: true,
  });

  const allData = useOutletContext();
  const auth = useAuth();

  const accountCodesAndNames = [
    { id: "151", name: "Local taxes/rates" },
    { id: "152", name: "Fees and Charges" },
    { id: "153", name: "Licenses" },
    { id: "154", name: "Levies" },
    { id: "155", name: "Permits" },
    { id: "156", name: "Land Charges" },
    { id: "157", name: "Other Incomes" },
    { id: "158", name: "National Support (Grants)" },
    { id: "159", name: "Donor Support" },
    { id: "111", name: "Total" },
    { id: "1", name: "Constituency Development" },
    { id: "2", name: "Local Governance" },
    { id: "3", name: "Integrated Development Planning" },
    { id: "4", name: "Economic and Business Development" },
    { id: "5", name: "Public Health and Environmental Protection" },
    { id: "6", name: "Housing and Community Amenities" },
    { id: "7", name: "Recreation Culture and Religion" },
    { id: "8", name: "Education and Skills Development" },
    { id: "9", name: "Social Protection" },
    { id: "10", name: "Public Order and Safety" },
    { id: "11", name: "Management and Support Services" },
    { id: "12", name: "Resource Mobilisation and Management" },
    { id: "000", name: "Rest" },
  ];
  

  
  const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

  useEffect(() => {
    axios
      .get(rootUrl(`/getCash/${auth.user?.cid}`))
      .then((response) => {
        const cash = response.data.data;
        setCashData(cash);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  function padWithZeros(input) {
  
    const str = input.toString();
  
    if (str.length === 1) {
      return "00" + str;
    } else if (str.length === 2) {
      return "0" + str;
    }
  
    return str;
  }

  const renderTableRows = () => {
    const rows = [];
    if(!allData.budget){
        return
    }

    

    const accounts = [...new Set(allData.budget.map(item => item.program))];
    let months = 1;

    let totalBudgetg = 0;
    let totalFlexedg = 0;
    let totalActualg = 0;
    let totalActualToDateg = 0;
    let totalDifferenceg = 0;
    

    accountCodesAndNames.forEach((account) => {
      let totalBudget = 0;
      let totalBudgets = 0;
      let totalFlexed = 0;
      let totalActual = 0;
      let totalActualToDate = 0;
      let totalFlexedPerformance = 0;
      let totalDifference = 0;
      let totalBuggedPerformance = 0;



      accounts.forEach((accountCode) => {
        if (account.id === accountCode) {
          const budgetEntries = allData.budget.filter(item => item.program === accountCode);
          const coaEntries = allData.subProgram.filter(item => item.programCode === accountCode);

          totalBudget = sumOfArray(budgetEntries.map(item => parseFloat(item.price * item.frequency * item.qty)));
          const flexed = (months / 12) * totalBudget;
          const coa = allData.coa.find(item => item.account === accountCode)?.id;
          const actual = sumOfArray(cashData.filter(item => item.coa_id === budgetEntries[0]?.id).map(item => parseFloat(item.amount)));

          if(totalBudget > 0 && !toggle){
            rows.push(
                <tr key={accountCode}>
                   {columnVisibility.accountCode && (
              <td className="border border-gray-300 py-2 px-2">{padWithZeros(accountCode)}{padWithZeros(coaEntries[0]?.subProgramCode)}</td>
                  )}
                   {columnVisibility.accountName && (
              <td className="border border-gray-300 py-2 px-2">{coaEntries[0]?.name}</td>
                  )}
                   {columnVisibility.totalBudget && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget)}</td>
                  )}
                  {columnVisibility.flexed && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(flexed)}</td>
                  )}
                   {columnVisibility.actual && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                  {columnVisibility.actualToDate && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                   {columnVisibility.performance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / flexed) * 100).toFixed()}%</td>
                  )}
                   {columnVisibility.difference && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget - actual)}</td>
                  )}
                  {columnVisibility.bPerformance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / totalBudget) * 100).toFixed()}%</td>
            )}
                </tr>
              );
          }
     
          totalBudgets += totalBudget;
          totalFlexed += flexed;
          totalActual += actual;
          totalActualToDate += actual;
          totalFlexedPerformance += (actual / flexed) * 100;
          totalDifference += totalBudget - actual;
          totalBuggedPerformance += (actual / totalBudget) * 100;
        }
      });


      if(totalBudget > 0){
        rows.push(
            <tr key={`${account.id}-total`} className={`${!toggle?'bg-gray-800 text-white':''} m-2 p-2`} >
            {columnVisibility.accountCode && (
            <td className="border border-gray-300 py-2 px-2">{padWithZeros(account.id)}</td>
            )}
            {columnVisibility.accountName && (
            <td className="border border-gray-300 py-2 px-2">{account.name}</td>
            )}
            {columnVisibility.totalBudget && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets)}</td>
            )}
            {columnVisibility.flexed && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexed)}</td>
            )}
            {columnVisibility.actual && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActual)}</td>
            )}
            {columnVisibility.actualToDate && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDate)}</td>
            )}
            {columnVisibility.performance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActual / totalFlexed) * 100).toFixed()}%</td>
            )}
            {columnVisibility.difference && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets - totalActual)}</td>
            )}
            {columnVisibility.bPerformance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActual / totalBudgets) * 100).toFixed()}%</td>
            )}
            </tr>
          );

        }

          
            totalBudgetg += totalBudgets
            totalFlexedg += totalFlexed;
            totalActualg += totalActual;
            totalActualToDateg += totalActualToDate;
            totalDifference += totalBudgetg - totalActualg;
          

          if(account.id == "111"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-900 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Income'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualg)}</td>
             )}
             {columnVisibility.bPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
         
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

          if(account.id == "000"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-900 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Expenditure'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualg)}</td>
             )}
             {columnVisibility.bPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

        
      

    });

    return rows;
  };

  const handleColumnToggle = (column) => {
    setColumnVisibility((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  return (
    <div className="cash-report">
      <h1 className='font-bold text-2xl my-3'>Receipts and Payments By Program</h1>
      <div className="flex gap-4 mb-4"> 
        <input
          type="date"
          className="border px-3 py-2 rounded"

        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
 
        />
        <button className='text-white bg-blue-900 p-3 m-2 rounded-lg' onClick={()=>setToggle(!toggle)}> <FaToggleOn/> </button>
      </div>
      <div className='my-5'>
      {Object.keys(columnVisibility).map((column) => (
          <label key={column} className="mr-4">
            <input
              type="checkbox"
              checked={columnVisibility[column]}
              onChange={() => handleColumnToggle(column)}
            />
            {column}
          </label>
        ))}
        </div>
      <table className="table-auto w-full border-collapse border border-gray-300 rounded-lg">
        <thead>
          
          <tr className='bg-blue-900 text-white'>
            {columnVisibility.accountCode && (
              <th className="border border-gray-300 py-2 px-2">Account Code</th>
            )}
            {columnVisibility.accountName && (
              <th className="border border-gray-300 py-2 px-2">Account Name</th>
            )}
            {columnVisibility.totalBudget && (
              <th className="border border-gray-300 py-2 px-2">Total Budget</th>
            )}
            {columnVisibility.flexed && (
              <th className="border border-gray-300 py-2 px-2">Flexed</th>
            )}
            {columnVisibility.actual && (
              <th className="border border-gray-300 py-2 px-2">Actual</th>
            )}
            {columnVisibility.actualToDate && (
              <th className="border border-gray-300 py-2 px-2">Actual to date</th>
            )}
            {columnVisibility.performance && (
              <th className="border border-gray-300 py-2 px-2">Actual Performance</th>
            )}
            {columnVisibility.difference && (
              <th className="border border-gray-300 py-2 px-2">Difference</th>
            )}
              {columnVisibility.bPerformance && (
              <th className="border border-gray-300 py-2 px-2">Budget Performance</th>
            )}
          </tr>
        </thead>
        <tbody>
          {renderTableRows()}
        </tbody>
      </table>
    </div>
  );
};

export default Receipts;
